import React from 'react';
import PropTypes from 'prop-types';
import ProductCarousel from './product-carousel';

const MAX_PRODUCTS = 5;

const toItem = (product) => ({
  key: `${product.id}-${product.themeTitle}`,
  title: product.title,
  subtitle: product.themeTitle,
  url: product.url,
  image: product.thumbnail,
  price: product.unitPrices[0].price,
  ariaLabel: `View ${product.title} - ${product.themeTitle} - From ${product.unitPrices[0].price}`,
});

const RecentProducts = ({ products, currentProductId, currentThemeTitle }) => {
  const items = products
    .filter(
      (p) => p.id !== currentProductId || p.themeTitle !== currentThemeTitle,
    )
    .slice(0, MAX_PRODUCTS)
    .map(toItem);

  return (
    <ProductCarousel
      id="recent-products-carousel"
      title={products.length > 1 ? 'Recently Viewed Products' : null}
      items={items}
    />
  );
};

RecentProducts.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      themeTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      thumbnail: PropTypes.string,
      unitPrices: PropTypes.arrayOf(
        PropTypes.shape({
          from: PropTypes.number.isRequired,
          price: PropTypes.number.isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
  currentProductId: PropTypes.number,
  currentThemeTitle: PropTypes.string,
};

export default RecentProducts;
